import { useToasts } from '@/hooks/Toasts/useToasts';
import mergeOperations from '@/util/shallowMerge';
import { useMutation } from '@apollo/client';
import { useCallback, useMemo, useRef, useState } from 'react';
import DEFAULT_OPERATIONS from './militaryDiscount.gql';

// eslint-disable-next-line import/no-anonymous-default-export
export default props => {
  const [, { addToast }] = useToasts();

  const { afterSubmit, uploadRef } = props;
  const operations = mergeOperations(DEFAULT_OPERATIONS, props.operations);

  const { addMilitaryDiscountMutation } = operations;

  const [isLoading, setIsLoading] = useState(false);

  const [addMilitaryDiscount, { data, error: addMilitaryDiscountError }] = useMutation(addMilitaryDiscountMutation, {
    fetchPolicy: 'no-cache',
  });

  const formApiRef = useRef(null);

  const handleSubmit = useCallback(
    async formState => {
      const { values } = formState;

      const { firstname, lastname, email } = values;

      setIsLoading(true);

      try {
        const { fileList, setFileList } = uploadRef.current;

        let image;

        if (fileList.length) {
          image = fileList[0].thumbUrl;
        }

        if (!image) {
          const message = 'Please upload your Image';

          addToast({
            type: 'error',
            message: message,
            dismissable: true,
            timeout: 1000,
          });

          setIsLoading(false);

          return;
        }

        await addMilitaryDiscount({
          variables: {
            firstname,
            lastname,
            email: email.trim(),
            image,
            type_id: 2,
          },
        });

        setFileList([]);

        formApiRef.current.reset();

        if (afterSubmit) {
          afterSubmit();
        }
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.error(error);
        }
      } finally {
        setIsLoading(false);
      }
    },
    [addMilitaryDiscount, addToast, afterSubmit, uploadRef],
  );

  const errors = useMemo(
    () => new Map([['addMilitaryDiscountError', addMilitaryDiscountError]]),
    [addMilitaryDiscountError],
  );

  return {
    isLoading,
    formApiRef,
    errors,
    handleSubmit,
    response: data && data.addDiscountInfo,
  };
};
